import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'
import type { PromoCodeMessageProps } from '../PromoCodeMessage.types'

export const withPromoAppliedSubscription = (WrappedComponent: Settle.FC<PromoCodeMessageProps>) => {
  const PromoCodeMessageSubscribed = (props: PromoCodeMessageProps) => {
    const { promoCode } = useAppliedPromoCodeContext()

    return promoCode?.applied ? <WrappedComponent {...props} /> : null
  }

  return PromoCodeMessageSubscribed
}
